import React from 'react'

import PropTypes from 'prop-types'
import {Flex, SimpleGrid, useMultiStyleConfig, Box, Link as ChakraLink} from '@chakra-ui/react'
import {
    FavouriteIcon,
    ProductRegistrationIcon,
    SupportIcon,
    AccountIcon,
    LogoutIcon,
} from '../icons'
import {getGlobalLink} from '../../utils/contentstack-utils'
import {useIntl} from 'react-intl'
import {AuthHelpers, useAuthHelper, useCustomerType} from '@salesforce/commerce-sdk-react'
import {useGigya} from '../../context/gigya'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {DrawerMenuItem} from './drawer-menu-item'
import {Link as RouterLink} from 'react-router-dom'

const DrawerMenuFirstLevel = ({
    primarycategories,
    categoriesData,
    onWishlistClick,
    setSelectedPrimaryCategoryId,
    headerLinks,
}) => {
    const styles = useMultiStyleConfig('KenwoodMenu')
    const intl = useIntl()
    const {isRegistered} = useCustomerType()
    const navigate = useNavigation()
    return (
        <SimpleGrid {...styles.firstLevelGrid}>
            <SimpleGrid {...styles.firstLevelCategoriesGrid}>
                {primarycategories.map((simpleLink) => {
                    const {label} = getGlobalLink({link: simpleLink?.redirects, categoriesData})
                    return (
                        <DrawerMenuItem
                            key={simpleLink.uid}
                            title={label}
                            handleClick={() => setSelectedPrimaryCategoryId(simpleLink.uid)}
                        />
                    )
                })}
            </SimpleGrid>
            <Box {...{w: 'full', borderBottom: 'small', borderColor: 'border.light'}} />
            <SimpleGrid {...styles.headerLinks}>
                {headerLinks?.[0] && (
                    <ChakraLink
                        as={RouterLink}
                        to={headerLinks?.[0]?.link?.href || '/'}
                        key={headerLinks?.[0]?._metadata?.uid}
                        {...styles.menuSupportLink}
                    >
                        <DrawerMenuItem
                            title={
                                headerLinks?.[0]?.link?.title ||
                                intl.formatMessage({
                                    defaultMessage: 'Support',
                                    id: 'drawerMenu.support',
                                })
                            }
                            svg={
                                <Flex {...styles.svgContainer}>
                                    <SupportIcon {...styles.headerIconSize} />
                                </Flex>
                            }
                        />
                    </ChakraLink>
                )}
                {headerLinks?.[1] && (
                    <ChakraLink
                        as={RouterLink}
                        to={headerLinks?.[1]?.link?.href || '/'}
                        key={headerLinks?.[1]?._metadata?.uid}
                        {...styles.menuSupportLink}
                    >
                        <DrawerMenuItem
                            title={
                                headerLinks?.[1]?.link?.title ||
                                intl.formatMessage({
                                    defaultMessage: 'Product Registration',
                                    id: 'drawerMenu.productRegistration',
                                })
                            }
                            handleClick={onWishlistClick}
                            svg={
                                <Flex {...styles.svgContainer}>
                                    <ProductRegistrationIcon {...styles.headerIconSize} />
                                </Flex>
                            }
                        />{' '}
                    </ChakraLink>
                )}
                {isRegistered && (
                    <DrawerMenuItem
                        title={intl.formatMessage({
                            defaultMessage: 'My Account',
                            id: 'header.popover.title.my_account',
                        })}
                        svg={
                            <Flex {...styles.svgContainer}>
                                <AccountIcon {...styles.headerIconSize} />
                            </Flex>
                        }
                        handleClick={() => navigate('/account')}
                    />
                )}
                <DrawerMenuItem
                    title={intl.formatMessage({
                        id: 'global.wishlist',
                        defaultMessage: 'Wishlist',
                    })}
                    handleClick={onWishlistClick}
                    svg={
                        <Flex {...styles.svgContainer}>
                            <FavouriteIcon {...styles.headerIconSize} />
                        </Flex>
                    }
                />

                {/* {headerLinks.map((headerLink) => (
                    <MenuCard
                        key={headerLink._metadata.uid}
                        title={headerLink.link.title}
                        url={headerLink.link.href}
                        image={headerLink.icon}
                        isAbsolute={headerLink?.is_external_url}
                        variant="secondary"
                        isLink
                    />
                ))} */}
                {isRegistered && <LogoutCard />}
            </SimpleGrid>
        </SimpleGrid>
    )
}

DrawerMenuFirstLevel.displayName = 'DrawerMenuFirstLevel'

DrawerMenuFirstLevel.propTypes = {
    primarycategories: PropTypes.array,
    setSelectedPrimaryCategoryId: PropTypes.func,
    categoriesData: PropTypes.object,
    onWishlistClick: PropTypes.func,
    headerLinks: PropTypes.array,
}

export {DrawerMenuFirstLevel}

function LogoutCard() {
    const styles = useMultiStyleConfig('KenwoodMenu')
    const intl = useIntl()

    const {gigyaObject} = useGigya()
    const logout = useAuthHelper(AuthHelpers.Logout)
    const navigate = useNavigation()

    const onSignoutClick = async () => {
        gigyaObject && gigyaObject.accounts && gigyaObject.accounts.logout()
        await logout.mutateAsync()
        navigate('/login')
    }

    return (
        <DrawerMenuItem
            title={intl.formatMessage({
                defaultMessage: 'Log out',
                id: 'header.popover.action.log_out',
            })}
            handleClick={() => onSignoutClick()}
            svg={
                <Flex {...styles.svgContainer}>
                    <LogoutIcon {...styles.headerIconSize} />
                </Flex>
            }
        />
    )
}
